<template>
  <div class="search-result-item mt-5 box-shadow p-4">
    <div>
      <a
        :href="childPageUrl + item.id + '.html'"
        aria-label="visit detail page"
      >
        <div
          v-sane-html="highlightText(searchText, item.fullTitle)"
          class="h3"
        />
      </a>
      <!-- <div
        v-if="item.dataType && item.dataType.length > 0"
        class="py-2"
      >
        <strong class="smallHeading text-green-cool"> {{ $t("dataPortal.list.dataType") }}: </strong>
        <span
          class="link"
          @click="() => searchTag('dataType', (item?.dataType?? []).join(''))"
        > {{ item.dataType[0] }} </span>
      </div> -->
      <p
        v-sane-html="highlightText(searchText, item.description)"
        class="py-1 text-ellipsis line2"
      />
      <div
        v-if="item.subjectAreas && item?.subjectAreas?.length > 0"
        class="py-1"
      >
        <p class="subjectAreas">
          <strong> {{ $t("dataPortal.list.subjectAreas") }}: </strong>  <span
            v-for="(subject, index) in item.subjectAreas"
            :key="'subject' + index"
          >
            <span
              v-sane-html="highlightText(searchText, subject)"
              class="link is-bold"
              @click="() => searchTag('subjectAreas', subject)"
            > {{ subject }}</span>
            <template v-if="index < (item.subjectAreas?.length ?? 0 ) -1">, </template>
          </span>
        </p>
      </div>
      <div
        v-if="item.tags && item.tags.length > 0"
        class="py-1"
      >
        <p class="subjectAreas">
          <strong> {{ $t("dataPortal.list.tags") }}: </strong>  <span
            v-for="(tag, index) in item.tags"
            :key="'tag' + index"
          >
            <a
              v-sane-html="highlightText(searchText, tag)"
              :aria-label="'search tag ' + tag"
              class="link is-bold"
              @click="() => searchTag('tags', tag)"
            > {{ tag }}</a><template v-if="index < (item.tags?.length ?? 0 ) -1">, </template>
          </span>
        </p>
      </div>
      <div
        v-if="item.publicationDate"
        class="py-1"
      >
        <p class="subjectAreas">
          <strong> {{ $t("dataPortal.list.publishedDate") }}: </strong>
          {{ item.publicationDate }}
        </p>
      </div>
      <!-- <div class="py-1">
        <p><strong> {{ $t("dataPortal.list.version") }}: </strong>: {{ item.version }} {{ formattedDate(item.publicationDate) }}</p>
      </div> -->
      <!-- <p>
        <a
          class="button is-brightGreen is-inverted svg nav-arrow-green-15 right arrow"
          :href="childPageUrl + item.id"
        >
          {{ $t("publication.list.detail") }} </a>
      </p> -->
    </div>
  </div>
</template>
<script setup lang="ts">
import { DatasetItem, dataDownloadSearchState, requestKeys } from '@/composables/state/dataDownloadSearchApp';
import { PropType } from 'vue';
import { highlightText, scrollToTopWithOffset } from '@/config/common';
const {
  resetToSingleFilter,
} = dataDownloadSearchState();
// const WEB_HOME_URL = import.meta.env.VITE_APP_HOME_URL ?? '';
// const DOWNLOAD_URL = import.meta.env.VITE_APP_PUBLICATION_DOWNLOAD_URL_PREFIX ?? '';
const props = defineProps({
  item: { type: Object as PropType<DatasetItem>, default: () => { return {}; } },
  childPageUrl: { type: String, default: '' },
  searchText: { type: String as PropType<string | null>, default: '' },
  // isListMode: { type: Boolean, default: false },
  additionalAction: { type: Function, default: null },
});

// const formattedDate = (dateTimeString: string | undefined) => {
//   if (!dateTimeString) return ''; // Check for null/undefined dateTimeString
//   return dateTimeString.split('T')[0];
// };

const searchTag = (fieldName: requestKeys, tag:string) => {
  resetToSingleFilter(fieldName, [tag]);
  props.additionalAction();
  scrollToTopWithOffset('#scrollToHere', 100);
};
</script>

<style scoped>
section.publicationFilters h3 { padding-bottom: 1rem; }

.link{
  color: #6D772C;
}
</style>
